/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Company } from '../model/company';
import { environment } from '../../../environments/environment';

@Injectable()
export class CompanyService {
    private environmenturl: string = environment.host + '/companies';
    private url: string = environment.host + '/company';
    private getAllCountiesURL: string = environment.host + '/country';
    private updateflags: string = environment.host + '/company/updateflags';
    // private compAuthenticationUrl: string = environment.host + '/companyAuthentication';
    private featureMetadataUrl:string = environment.host + '/feature/metadata';
    private featureDataUrl:string = environment.host+'/feature';

    constructor(private http: HttpClient) {}

    public getAllCompanies() {
        const URL=this.url+'?tabType=CMPV';
        return this.http.get(URL.toString()).toPromise();
    }

    public getAllCountries() {
        return this.http.get(this.getAllCountiesURL.toString()).toPromise();
    }

    public createCompany(company: Company) {
        return this.http.post(this.url.toString(), company).toPromise();
    }

    public getCompanyDetails(companyId: any) {
        return this.http.get(this.url.toString() + '\\' + companyId).toPromise();
    }

    public updateCompany(company: Company) {
        return this.http.put(this.url.toString(), company).toPromise();
    }

    public updateCompanyFlags(company: any) {
        return this.http.put(this.updateflags.toString(), company).toPromise();
    }

    public deleteCompany(company: Company) {
        return this.http.delete(this.url.toString() + '\\' + company.id).toPromise();
    }

    public createUpdateCompanies(companyData: any) {
        return this.http.post(this.environmenturl.toString(), companyData).toPromise();
    }

    // updateCompanyAuthentication(payload: any) {
    //     return this.http.put(this.compAuthenticationUrl.toString(), payload).toPromise();
    // }

    // getCompanyAuthentication(companyName: string) {
    //     return this.http.get(this.compAuthenticationUrl.toString() + '/' + companyName).toPromise();
    // }

    public getFeatureMetadata(){
        return this.http.get(this.featureMetadataUrl).toPromise();
    }

    public getFeatureConfigDetails(company: any){
        return this.http.get(this.featureDataUrl.toString() + '/'+ company).toPromise();
    }
    
    public postFeatureConfigDetails(company: any, payload: any){
        return this.http.post(this.featureDataUrl.toString() + '/'+ company, payload).toPromise();
    }
}
